/* Opt-in presentation; values follow Reports without loading its page styles. */
.import-files-page {
  min-width: 0;
  overflow-wrap: anywhere;
}

.import-files-page:has(> .import-content) {
  max-width: 1344px;
}

.import-files-page .import-content {
  container: imports / inline-size;
  display: grid;
  min-width: 0;
  gap: 16px;
}

.import-files-page .import-hero {
  position: relative;
  isolation: isolate;
  min-height: 72px;
  padding: 6px 20px;
  overflow: clip;
  border: 1px solid var(--color-line-soft);
  border-radius: 4px;
  background: white;
}

.import-files-page .import-hero::before {
  position: absolute;
  z-index: -1;
  inset: 0 0 0 auto;
  width: 54%;
  max-width: 434px;
  content: "";
  background-image: url("/brand/reports/transia-grain-banner.png");
  background-position: right center;
  background-size: auto 100%;
  background-repeat: no-repeat;
  mask-image: linear-gradient(90deg, transparent 10%, rgb(0 0 0 / 0.025) 18%, rgb(0 0 0 / 0.10) 26%, rgb(0 0 0 / 0.30) 34%, rgb(0 0 0 / 0.60) 42%, rgb(0 0 0 / 0.86) 48%, black 56%);
}

.import-files-page .import-hero > div {
  align-items: center;
  padding-right: clamp(330px, 32cqw, 440px);
}

.import-files-page .import-hero h1 {
  font-size: clamp(24px, 2.2cqw, 28px);
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -0.035em;
}

.import-files-page .import-hero [aria-hidden='true']:has(> svg) {
  width: 32px;
  height: 32px;
}

.import-files-page .import-hero [aria-hidden='true'] > svg {
  width: 20px;
  height: 20px;
}

.import-files-page .import-hero-subtitle {
  display: block;
  margin-top: 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--color-slate-800);
}

.import-files-page .import-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 16px;
  padding: 18px;
  border: 1px solid var(--color-slate-200);
  border-radius: 4px;
  background: white;
  box-shadow: 0 2px 8px rgb(15 23 42 / 0.035);
}

.import-files-page .import-section-heading,
.import-files-page .import-selection-actions,
.import-files-page .import-source-actions,
.import-files-page .import-converter-actions,
.import-files-page .import-storage-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
  gap: 8px;
}

.import-files-page .import-section-heading,
.import-files-page .import-source-actions {
  justify-content: space-between;
}

.import-files-page .import-bypass > label {
  flex: 1 1 420px;
}

.import-files-page .import-section-heading:has(> .import-card-header) {
  align-items: flex-start;
}

.import-files-page .import-section-heading > .import-card-header {
  flex: 1 1 260px;
}

.import-files-page .import-card-header,
.import-files-page .import-history-heading {
  display: flex;
  align-items: flex-start;
  min-width: 0;
  gap: 12px;
}

.import-files-page .import-history-heading,
.import-files-page .import-storage-heading {
  align-items: center;
}

.import-files-page .import-card-title {
  margin: 2px 0 4px;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.025em;
  color: var(--color-slate-950);
}

.import-files-page .import-selection-title {
  margin: 0;
  padding-left: 12px;
  border-left: 3px solid var(--color-accent);
}

.import-files-page .import-source-title {
  margin-top: 4px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.025em;
  color: var(--color-slate-950);
}

.import-files-page .import-card-icon {
  display: inline-flex;
  flex: 0 0 46px;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 4px;
  background: color-mix(in srgb, var(--color-accent) 8%, white);
  color: var(--color-accent-strong);
}

.import-files-page .import-eyebrow {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--color-slate-500);
}

.import-files-page .import-description {
  font-size: 12px;
  line-height: 1.45;
  color: var(--color-slate-500);
}

.import-files-page .import-source-grid,
.import-files-page .import-converters {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: stretch;
  min-width: 0;
  gap: 16px;
}

.import-files-page .import-file-field,
.import-files-page .import-converter-body {
  display: grid;
  min-width: 0;
  gap: 8px;
}

.import-files-page .import-converter-body {
  gap: 12px;
}

.import-files-page .import-field-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--color-slate-900);
}

.import-files-page .import-file-picker {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
  gap: 8px 12px;
  border-radius: 4px;
}

.import-files-page .import-file-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 6px 10px;
  border: 1px solid var(--color-slate-300);
  border-radius: 4px;
  background: white;
  color: var(--color-slate-700);
  font-size: 12px;
  font-weight: 500;
}

.import-files-page .import-source-card .import-file-picker {
  flex-direction: column;
  align-items: stretch;
}

.import-files-page .import-file-name {
  min-width: 0;
  font-size: 12px;
  line-height: 1.45;
  white-space: normal;
  overflow-wrap: anywhere;
}

.import-files-page .import-source-actions {
  margin-top: auto;
}

.import-files-page .import-converter-actions,
.import-files-page .import-storage-actions {
  justify-content: flex-end;
}

.import-files-page .import-converter-actions > button:has(> .lucide-map-pin) {
  margin-right: auto;
}

.import-files-page button,
.import-files-page .import-storage-upload {
  min-height: 36px;
  min-width: 0;
  max-width: 100%;
  border-radius: 4px;
  white-space: normal;
}

.import-files-page button > svg,
.import-files-page label > svg {
  flex-shrink: 0;
}

.import-files-page .import-selection-actions > span {
  max-width: 100%;
}

.import-files-page .import-primary-action {
  border-color: var(--color-accent) !important;
  background: var(--color-accent) !important;
  color: white !important;
  transform: none !important;
}

.import-files-page .import-primary-action:hover:not(:disabled) {
  border-color: var(--color-accent-strong) !important;
  background: var(--color-accent-strong) !important;
}

.import-files-page button:disabled,
.import-files-page .import-storage-upload[aria-disabled='true'],
.import-files-page .import-file-field:has(> input:disabled) .import-file-trigger {
  border-color: var(--color-slate-200) !important;
  background: var(--color-slate-50) !important;
  background-image: none !important;
  color: var(--color-slate-400) !important;
  box-shadow: none !important;
  opacity: 1 !important;
  transform: none !important;
}

.import-files-page .import-file-picker:hover .import-file-trigger {
  border-color: var(--color-slate-400);
  background: var(--color-slate-50);
  color: var(--color-slate-900);
}

.import-files-page .import-file-field:has(> input:disabled) .import-file-picker {
  opacity: 1;
}

.import-files-page :is(button, input, select, textarea, a, [tabindex]):focus-visible,
.import-files-page .import-storage-upload:has(input:focus-visible),
.import-files-page .import-file-field:has(> input:focus-visible) .import-file-trigger {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.import-files-page .import-table {
  min-width: 0;
  border: 1px solid var(--color-slate-200);
  border-radius: 4px;
}

.import-files-page .import-table table {
  width: 100%;
  table-layout: fixed;
}

.import-files-page .import-table th {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.import-files-page .import-table td {
  white-space: normal;
  overflow-wrap: anywhere;
}

.import-files-page .import-storage-table :is(th, td):first-child {
  width: 27%;
}

.import-files-page .import-storage-table :is(th, td):last-child {
  width: 34%;
}

.import-files-page .import-table tbody > tr:nth-child(even) {
  background: var(--color-slate-50);
}

@container imports (min-width: 600px) {
  .import-files-page .import-source-grid {
    grid-template-columns: repeat(min(2, var(--import-source-count, 5)), minmax(0, 1fr));
  }
}

@container imports (min-width: 900px) {
  .import-files-page .import-source-grid {
    grid-template-columns: repeat(min(3, var(--import-source-count, 5)), minmax(0, 1fr));
  }

  .import-files-page .import-converters {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@container imports (min-width: 1280px) {
  .import-files-page .import-source-grid {
    grid-template-columns: repeat(min(5, var(--import-source-count, 5)), minmax(0, 1fr));
  }
}

@media (max-width: 979px) {
  .import-files-page .import-hero {
    min-height: 0;
    padding: 12px 16px;
  }

  .import-files-page .import-hero::before {
    display: none;
    background-image: none;
  }

  .import-files-page .import-hero > div {
    padding-right: 0;
  }
}

@container imports (max-width: 719px) {
  .import-files-page .import-card {
    padding: 16px;
  }

  .import-files-page .import-hero [aria-hidden='true']:has(> svg) {
    width: 40px;
    height: 40px;
  }

  .import-files-page .import-hero-subtitle {
    font-size: 15px;
  }

  .import-files-page .import-table :is(table, tbody) {
    display: block;
    width: 100%;
  }

  .import-files-page .import-table thead {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
  }

  .import-files-page .import-table tr {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 12px;
    gap: 8px 12px;
  }

  .import-files-page .import-table td {
    display: block;
    width: auto !important;
    min-width: 0;
    padding: 0;
  }

  .import-files-page .import-table td::before {
    display: block;
    margin-bottom: 2px;
    color: var(--color-slate-500);
    content: attr(data-label);
    font-size: 10px;
    font-weight: 600;
  }

  .import-files-page .import-storage-table td:is(:first-child, :nth-child(2), :last-child),
  .import-files-page .import-history-table td:nth-child(n + 3) {
    grid-column: 1 / -1;
  }

  .import-files-page .import-storage-actions {
    justify-content: flex-start;
  }
}
